import React from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../molecules/FlexRow'
import BasicTable from '../../../../atoms/BasicTable'
import Job from './Job'

function Source ({ source }) {
  return (
    <div className='p-md' style={{ borderLeft: '5px solid var(--border-color-neutral-normal)' }}>
      <FlexRow>
        <div className='w-full font-bold font-size-sm' style={{ borderBottom: 'var(--border-neutral-thin)' }}>{source.label}</div>
      </FlexRow>
      <BasicTable className='pt-2 table-fixed w-full' style={{ width: '100%', tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th className='px-2'>Job Key</th>
            <th className='px-2'>Description</th>
            <th className='px-2'>Status</th>
            <th className='px-2'>Started</th>
            <th className='px-2'>Finished</th>
            <th className='px-2'>Last Activity</th>
            <th className='px-2'>Metrics</th>
            <th className='px-2'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {(source.jobs || []).map(job => (
            <Job key={job.jobKey} job={job} />
          ))}
        </tbody>
      </BasicTable>
    </div>
  )
}

Source.propTypes = {
  source: PropTypes.object
}

export default Source
